<template>
    <div>
        <b-row class="btn-bottom-marging">
            <b-col cols="12">
                <router-link to="/roles/create">
                    <b-button type="submit" size="sm" variant="success" class="btn btn-success pull-right" v-if="$can('Create_role', 'all')">
                        <i class="fa fa-plus"></i> Create Role
                    </b-button>
                </router-link>    
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>

.search-panel-btn {
  float: right;
}

.btn-bottom-marging {
    margin-bottom: 10px;
}

</style>